// extracted by mini-css-extract-plugin
export default {"downloadContainer":"styles_downloadContainer__1ggNB","collectionContainer":"styles_collectionContainer__e+jd0","deletePopUpContainer":"styles_deletePopUpContainer__kJ+m3"};